import React from 'react'
import { AlertTriangle } from 'lucide-react'

const CompanyComplianceAlerts = () => (
  <div className="space-y-6">
    <div className="flex items-center">
      <AlertTriangle className="w-6 h-6 text-primary-600 mr-2" />
      <h1 className="text-2xl font-bold text-secondary-900">Compliance & Alerts</h1>
    </div>
    <div className="card p-6 text-secondary-600">Compliance alerts placeholder</div>
  </div>
)

export default CompanyComplianceAlerts


